import { ThunkAction } from 'redux-thunk'
import { Action, Store } from 'redux'

import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  GET_PRIMARY_COUNTRY_LIST_ACTION,
  GET_PRIMARY_STATE_LIST_ACTION,
  GET_PRIMARY_CITY_LIST_ACTION,
  GET_ALTERNATE_STATE_LIST_ACTION,
  GET_ALTERNATE_CITY_LIST_ACTION,
  GET_ORGANIZATION_ACTION,
} from '../constants/action-types'
import {
  COUNTRY_URL,
  STATE_URL,
  CITY_URL,
  GET_ORGANIZATION_PROFILE_URL,
} from '../../service/apiEndPoints'
import { successToast } from '../../util/utils'

/**
 * country list
 * @returns
 */
export const countryList =
  (): ThunkAction<void, Store, unknown, Action<string>> => (dispatch) => {
    dispatch({
      type: GET_PRIMARY_COUNTRY_LIST_ACTION.GET_PRIMARY_COUNTRY_LIST_INITIALIZATION,
    })
    apiCall(
      COUNTRY_URL,
      (res: any) => {
        dispatch({
          type: GET_PRIMARY_COUNTRY_LIST_ACTION.GET_PRIMARY_COUNTRY_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      (err: any) => {
        dispatch({
          type: GET_PRIMARY_COUNTRY_LIST_ACTION.GET_PRIMARY_COUNTRY_LIST_FAILED,
          payload: err.message,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 * state list
 * @param showToast
 * @param ID
 * @returns
 */
export const stateList =
  (id, isPrimary): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: isPrimary
        ? GET_PRIMARY_STATE_LIST_ACTION.GET_PRIMARY_STATE_LIST_INITIALIZATION
        : GET_ALTERNATE_STATE_LIST_ACTION.GET_ALTERNATE_STATE_LIST_INITIALIZATION,
    })

    apiCall(
      STATE_URL,
      (res: any) => {
        dispatch({
          type: isPrimary
            ? GET_PRIMARY_STATE_LIST_ACTION.GET_PRIMARY_STATE_LIST_SUCCESS
            : GET_ALTERNATE_STATE_LIST_ACTION.GET_ALTERNATE_STATE_LIST_SUCCESS,

          payload: res?.data,
        })
      },
      (err: any) => {
        dispatch({
          type: isPrimary
            ? GET_PRIMARY_STATE_LIST_ACTION.GET_PRIMARY_STATE_LIST_FAILED
            : GET_ALTERNATE_STATE_LIST_ACTION.GET_ALTERNATE_STATE_LIST_FAILED,
          payload: err.message,
        })
      },
      {
        params: {
          country_id: id,
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 * city list
 * @param showToast
 * @param ID
 * @returns
 */
export const cityList =
  (id, isPrimary): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: isPrimary
        ? GET_PRIMARY_CITY_LIST_ACTION.GET_PRIMARY_CITY_LIST_INITIALIZATION
        : GET_ALTERNATE_CITY_LIST_ACTION.GET_ALTERNATE_CITY_LIST_INITIALIZATION,
    })
    apiCall(
      CITY_URL,
      (res: any) => {
        dispatch({
          type: isPrimary
            ? GET_PRIMARY_CITY_LIST_ACTION.GET_PRIMARY_CITY_LIST_SUCCESS
            : GET_ALTERNATE_CITY_LIST_ACTION.GET_ALTERNATE_CITY_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      (err: any) => {
        dispatch({
          type: isPrimary
            ? GET_PRIMARY_CITY_LIST_ACTION.GET_PRIMARY_CITY_LIST_FAILED
            : GET_ALTERNATE_CITY_LIST_ACTION.GET_ALTERNATE_CITY_LIST_FAILED,
          payload: err.message,
        })
      },
      {
        params: {
          state_id: id,
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 *get organization profile data
 * @param organizationId
 * @returns
 */
export const getOrganization =
  (organizationId): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_ORGANIZATION_ACTION.GET_ORGANIZATION_INITIALIZATION,
    })
    apiCall(
      GET_ORGANIZATION_PROFILE_URL(organizationId),
      (res: any) => {
        dispatch({
          type: GET_ORGANIZATION_ACTION.GET_ORGANIZATION_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_ORGANIZATION_ACTION.GET_ORGANIZATION_FAILED,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 * Edit organization profile
 * @param values
 * @param organizationId
 * @returns
 */
export const editOrganization =
  (
    values,
    organizationId,
    onSuccess?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_ORGANIZATION_ACTION.GET_ORGANIZATION_INITIALIZATION,
    })
    apiCall(
      GET_ORGANIZATION_PROFILE_URL(organizationId),
      (res: any) => {
        dispatch({
          type: GET_ORGANIZATION_ACTION.GET_ORGANIZATION_SUCCESS,
          payload: res?.data,
        })
        dispatch(getOrganization(organizationId))
        onSuccess && onSuccess()
        successToast('Profile updated successfully.')
      },
      () => {
        dispatch({
          type: GET_ORGANIZATION_ACTION.GET_ORGANIZATION_FAILED,
        })
      },
      values,
      METHOD.PUT,
      {
        showToast: false,
      }
    )
  }
